import { useEffect } from 'react';
import { useRouter } from 'next/router';

export default function useSurfsidePageView() {
  const router = useRouter();

  useEffect(() => {
    if (window && typeof window.surf === 'function' && router.asPath) {
      window.surf('trackPageView:lume');
    }
  }, [router.asPath]);
}
